/*

 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-07-22 16:07:07
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-29 11:16:14
 * @FilePath: \crm-product\found\views\mdm\views\adjustment_supply\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%A
 */
import TablePage from '../../../../../components/table_page';
import Modal from '../../../../../components/modal';
import request from '../../../../../utils/request';
import Form from '../form/index';
import {
  ProcessLog,
} from '../../../../../modules';
import ChangeRecord from '../form/detail.vue';

export default {
  extends: TablePage,
  props: {},
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  components: {
    Modal,
    Form,
    ProcessLog,
    ChangeRecord,
  },
  created() {
    this.getConfigList('main-list');
  },
  methods: {
    clickVisible({
      row,
      val: {
        code,
      },
    }) {
      const {
        processNo,
        processStatus,
      } = row;
      if (code === 'process_log' && !processNo) {
        return false;
      }
      if (code === 'edit' && ['2', '4'].includes(processStatus)) {
        return false;
      }
      return true;
    },

    modalClick({
      val,
      row,
    }) {
      this.formConfig = {
        ...val,
      };
      if (val.code === 'add_adjust') {
        this.formName = 'Form';
        this.formConfig = {
          ...val,
        };
        this.modalConfig.title = '新增';
        this.openFull();
      } else if (val.code === 'edit') {
        this.formName = 'Form';
        this.formConfig = {
          ...val,
          row,
          customerCode: row.customerCode,
        };
        this.modalConfig.title = '编辑';
        this.openFull();
      } else if (val.code === 'view') {
        this.formName = 'Form';
        this.formConfig = {
          ...val,
          row,
          customerCode: row.customerCode,
          code: 'view',
        };
        this.modalConfig.title = '查看';
        this.openFull();
      } else if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: {
            processNo: row.processNo,
          },
        };

        this.modalConfig.title = '流程日志';

        this.formName = 'ProcessLog';
        this.openDrawer();
      } else if (val.code === 'changeRecord') {
        this.formConfig = {
          mainId: row.id,
        };
        this.formName = 'ChangeRecord';
        this.modalConfig.title = '变更记录';
        this.openFull();
      }
    },
    // 提交审批回调
    onSubmit(params) {
      const configParams = {
        ...params,
        code: 'approve',
      };

      this.$emit('approve', configParams);
    },

  },
};
